import i18n from "./i18n";

export function formatCurrency(value: number, withSymbol = true) {
  const currentLocale = i18n.language || "pt-BR"; // fallback caso não carregue

  return Number(value).toLocaleString(currentLocale, {
    style: withSymbol ? "currency" : "decimal",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
}
